module.exports = __webpack_public_path__ + "img/logo_leadjet_grey.b7f1cc33.png";